import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({
  fonts: {
    heading: `'Microsoft YaHei','Open Sans', sans-serif`,
    body: `'Microsoft YaHei','Raleway', sans-serif`,
  },
  components: {
    Table: {
      baseStyle: {
        th: {
          fontSize: '48px', // Set larger font size for table headers
        },
      },
    },
  },
});
